import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BingImageResult } from "../models/BingImageResult";

@Injectable({ providedIn: "root" })
export class BingService {

  constructor(private handler: HttpBackend) { }

  getImagesByKeyword(keyword: string): Observable<BingImageResult> {

    const headerDict = {
      'Ocp-Apim-Subscription-Key': environment.subscriptionKey
    };

    const requestOptions = new HttpHeaders(headerDict);

    const http = new HttpClient(this.handler);

    return http.get<BingImageResult>(`${environment.bingImageSearchEndpoint}?q=${keyword}&minWidth=450`, { headers: requestOptions });
  }
}
